import React from 'react';
import PropTypes from 'prop-types';
import {Button, Dialogue, Dropdown, DropdownItem, IconButton} from '@albert-io/atomic';
import {getModelForResourceType} from 'resources/modelRegistry';
import {invalidatePartialInterest, genericMandarkRequest} from 'resources/mandark.resource';
import ManageRosterContext from 'client/Classrooms/Classroom/Teacher/ManageRoster/ManageRoster.context';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';
import errorCodes from 'client/errorCodes';

import ConfirmActionModal from 'client/components/ConfirmActionModal/ConfirmActionModal.react';

export default class InvitedStudentsActionsDropdown extends React.Component {
  static propTypes = {
    invitation: PropTypes.instanceOf(getModelForResourceType('classroom_invitation_v1'))
  };

  constructor() {
    super();

    this.state = {
      showRemoveModal: false,
      showResendModal: false
    };
  }

  handleRemoveInvitation = () => this.props.invitation.delete();

  handleSendInvitation = () => {
    const classroomId = this.context.classroom.getId();
    const teacherId = masqueradeStore.getUserIdByMasqueradeState();
    const email = this.props.invitation.getEmail();

    return genericMandarkRequest(
      'post',
      {
        resourcePath: ['json', 'classroom_invitations', 'reinvite']
      },
      {
        data: {
          attributes: {
            classroom_id: classroomId,
            issuer_id: teacherId,
            email
          }
        }
      }
    );
  };

  handleSuccess = () => {
    invalidatePartialInterest(this.context.queries.invitations.done());
    this.context.setIsReady(false);
  };

  handleCloseHardCapExceededModal = () => {
    this.setState({showExceededHardCapModal: false});
  };

  static contextType = ManageRosterContext;

  render() {
    const {invitation} = this.props;
    return (
      <>
        <Dropdown
          trigger={<IconButton icon='ellipsis-v' label='menu' />}
          position='bottom-end'
          data-testid='invited-students-actions-dropdown'
        >
          <DropdownItem
            as='button'
            icon={['fal', 'envelope']}
            onClick={() =>
              this.setState(({showResendModal}) => ({
                showResendModal: !showResendModal
              }))
            }
          >
            Re-send invitation
          </DropdownItem>
          <DropdownItem
            as='button'
            color='red'
            icon={['fal', 'trash-alt']}
            iconColor='negative'
            onClick={() =>
              this.setState(({showRemoveModal}) => ({
                showRemoveModal: !showRemoveModal
              }))
            }
          >
            Remove invitation
          </DropdownItem>
        </Dropdown>
        {this.state.showRemoveModal && (
          <ConfirmActionModal
            align='center'
            handleClose={() => this.setState({showRemoveModal: false})}
            makeRequest={this.handleRemoveInvitation}
            onResolve={this.handleSuccess}
          >
            {({isRequestInflight, onCancel, onConfirm}) => (
              <>
                <Dialogue.Body align='center'>
                  Are you sure you want to remove the invitation for
                  <br />
                  <strong>{invitation.getEmail()}</strong>?
                </Dialogue.Body>
                <Dialogue.BtnGroup align='center'>
                  <Button color='secondary' disabled={isRequestInflight} onClick={onCancel}>
                    Cancel
                  </Button>
                  <Button color='negative' disabled={isRequestInflight} onClick={onConfirm}>
                    Remove
                  </Button>
                </Dialogue.BtnGroup>
              </>
            )}
          </ConfirmActionModal>
        )}
        {this.state.showResendModal && (
          <ConfirmActionModal
            align='center'
            handleClose={() => this.setState({showResendModal: false})}
            makeRequest={this.handleSendInvitation}
            onResolve={this.handleSuccess}
            onReject={(error) => {
              const errorCode = error.response.body.errors[0].code;
              if (errorCode === errorCodes.FORBIDDEN.EXCEEDED_HARD_CAP_LIMIT) {
                this.setState({showExceededHardCapModal: true, showResendModal: false});
              }
            }}
          >
            {({isRequestInflight, onCancel, onConfirm}) => (
              <>
                <Dialogue.Body align='center'>
                  A new invitation to
                  <br />
                  <strong>{this.context.classroom.getName()}</strong> will be sent to
                  <br />
                  <strong>{invitation.getEmail()}</strong>.
                </Dialogue.Body>
                <Dialogue.BtnGroup align='center'>
                  <Button color='secondary' disabled={isRequestInflight} onClick={onCancel}>
                    Cancel
                  </Button>
                  <Button disabled={isRequestInflight} onClick={onConfirm}>
                    Send
                  </Button>
                </Dialogue.BtnGroup>
              </>
            )}
          </ConfirmActionModal>
        )}
        {this.state.showExceededHardCapModal && (
          <ConfirmActionModal align='center' handleClose={this.handleCloseHardCapExceededModal}>
            {() => (
              <>
                <Dialogue.Body>
                  <strong>
                    Could not could not resend invitation because your school&apos;s license has
                    reached it&apos;s seat limit.
                  </strong>
                </Dialogue.Body>
                <Dialogue.BtnGroup>
                  <Button color='secondary' onClick={this.handleCloseHardCapExceededModal}>
                    Close
                  </Button>
                </Dialogue.BtnGroup>
              </>
            )}
          </ConfirmActionModal>
        )}
      </>
    );
  }
}
